import breakPoints from 'assets/styles/jsVariables/breakpoints';

export const MOBILE_VIEW = ({ innerWidth }) =>
  innerWidth <= parseInt(breakPoints.breakPointXs, 10);
export const TABLET_VIEW = ({ innerWidth }) =>
  innerWidth > parseInt(breakPoints.breakPointXs, 10) &&
  innerWidth <= parseInt(breakPoints.breakPointSm, 10);
export const DESKTOP_VIEW = ({ innerWidth }) =>
  innerWidth > parseInt(breakPoints.breakPointSm, 10);


export function getWindowDimension() {
  return {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  };
}

export function applyFixToWindowPosition() {
  document.body.classList.remove('relativeBlock');
  document.body.classList.add('fixedBlock');
}

export function applyRelativeToWindowPosition() {
  document.body.classList.remove('fixedBlock');
  document.body.classList.add('relativeBlock');
}

export default {
  getWindowDimension
};



// WEBPACK FOOTER //
// ./src/libs/windowDimension.js